import './AppContainer.css'

const AppContainer = ({ app }) => (
  <div className='app'>
    <div className='app__logo-container'>
      <img src={app.logo} alt={app.name} className='app__logo' />
    </div>
    
    <h3 className='app__name'>{app.name}</h3>
    
    {app.description && (
      <p className='app__description'>{app.description}</p>
    )}

    <div className='app__links'>
      {app.appStore && (
        <a
          href={app.appStore}
          target='_blank'
          rel='noreferrer'
          className='link link--icon'
          aria-label='Download on App Store'
        >
          <img 
            src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" 
            alt="Download on App Store"
            className='app__badge'
          />
        </a>
      )}

      {app.playStore && (
        <a
          href={app.playStore}
          target='_blank'
          rel='noreferrer'
          className='link link--icon'
          aria-label='Get it on Google Play'
        >
          <img 
            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" 
            alt="Get it on Google Play"
            className='app__badge'
          />
        </a>
      )}
    </div>
  </div>
)

export default AppContainer
